/* The Clay Arts: Our Story + Contact pages (fh-*). Runs after fh-home.js (navbar, overlays, reveals).
   Ported from the reference story.js and contact.js. Written without backslashes on purpose. */
(function () {
  'use strict';

  var DIGITS = '0123456789';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     Our Story: the stats roll up digit by digit the first time they scroll into view.
     The final numbers are already in the HTML, so no-JS and reduced-motion visitors just see them.
     --------------------------------------------------------- */
  function initRolls(scope) {
    var rolls = Array.prototype.slice.call(scope.querySelectorAll('.fh [data-roll]:not([data-roll-done])'));
    if (!rolls.length || !('IntersectionObserver' in window) || reduceMotion) return;
    rolls.forEach(function (el) {
      el.setAttribute('data-roll-done', '');
      var text = el.textContent;
      el.textContent = '';
      text.split('').forEach(function (ch, i) {
        var part = document.createElement('span');
        if (DIGITS.indexOf(ch) > -1) {
          part.className = 'fh-roll-digit';
          var strip = document.createElement('span');
          strip.className = 'fh-roll-strip';
          strip.style.setProperty('--d', ch);
          strip.style.transitionDelay = (i * 0.07) + 's';
          for (var d = 0; d <= 9; d++) {
            var n = document.createElement('span');
            n.textContent = d;
            strip.appendChild(n);
          }
          part.appendChild(strip);
        } else {
          part.className = 'fh-roll-sym';
          part.textContent = ch;
        }
        el.appendChild(part);
      });
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.classList.add('is-rolled');
      });
    }, { threshold: 0.6 });
    rolls.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------
     Contact: checks the form before it posts to Shopify (which emails the store) and fills
     contact[name] from the first and last name.
     Delegated from document in the CAPTURE phase with stopImmediatePropagation: Shopify's spam
     protection listens on document and would otherwise re-submit an invalid form by itself.
     The fields keep native required/type/minlength, so nothing posts even without this file.
     --------------------------------------------------------- */
  function digitCount(v) {
    var c = 0;
    for (var i = 0; i < v.length; i++) if (DIGITS.indexOf(v.charAt(i)) > -1) c++;
    return c;
  }
  function onlyChars(v, allowed) {
    for (var i = 0; i < v.length; i++) if (allowed.indexOf(v.charAt(i)) === -1) return false;
    return true;
  }
  function validEmail(v) {
    var at = v.indexOf('@');
    var dot = v.lastIndexOf('.');
    return v.indexOf(' ') === -1 && at > 0 && at === v.lastIndexOf('@') && dot > at + 1 && v.length - dot - 1 >= 2;
  }
  var rules = {
    // the wholesale enquiry form: one name field and the company
    'fh-cf-name': function (v) { return v.length >= 2 ? '' : 'Please enter your full name.'; },
    'fh-cf-company': function (v) { return v.length >= 2 ? '' : 'Please enter your company name.'; },
    'fh-cf-first': function (v) { return v.length >= 2 ? '' : 'Please enter your first name.'; },
    'fh-cf-last': function (v) { return v.length >= 2 ? '' : 'Please enter your last name.'; },
    'fh-cf-email': function (v) { return validEmail(v) ? '' : 'Please enter a valid email address.'; },
    'fh-cf-phone': function (v) {
      var n = digitCount(v);
      return onlyChars(v, DIGITS + '+ ().-') && n >= 10 && n <= 15 ? '' : 'Please enter a phone number with at least 10 digits.';
    }
  };

  function check(input) {
    var rule = rules[input.id];
    if (!rule) return true;
    var message = rule(input.value.trim());
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    var err = document.getElementById(input.id + '-error');
    if (err) err.textContent = message;
    return !message;
  }

  function formOf(el) { return el && el.closest ? el.closest('[data-fh-contact-form]') : null; }

  // The browser's own bubbles are replaced by the inline messages
  document.addEventListener('invalid', function (e) {
    if (!formOf(e.target)) return;
    e.preventDefault();
    check(e.target);
  }, true);

  document.addEventListener('focusout', function (e) {
    if (formOf(e.target) && rules[e.target.id] && e.target.value.trim()) check(e.target);
  });
  document.addEventListener('input', function (e) {
    if (formOf(e.target) && e.target.getAttribute('aria-invalid') === 'true') check(e.target);
  });

  document.addEventListener('submit', function (e) {
    var form = formOf(e.target);
    if (!form || form !== e.target) return;
    var status = form.querySelector('[data-fh-cf-status]');
    var submit = form.querySelector('.fh-cf-submit');
    var firstBad = null;
    Object.keys(rules).forEach(function (id) {
      var input = form.querySelector('#' + id);
      if (input && !check(input) && !firstBad) firstBad = input;
    });
    if (firstBad) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (status) { status.classList.remove('is-ok'); status.textContent = 'Please check the highlighted fields.'; }
      firstBad.focus();
      return;
    }
    var full = form.querySelector('[data-fh-cf-fullname]');
    if (full && form.querySelector('#fh-cf-first')) full.value = (form.querySelector('#fh-cf-first').value.trim() + ' ' + form.querySelector('#fh-cf-last').value.trim()).trim();
    if (status) status.textContent = '';
    if (submit) {
      if (!submit.getAttribute('data-label')) submit.setAttribute('data-label', submit.textContent);
      // disabled a tick later, so the submit itself is not cancelled (no double sends while the page loads)
      setTimeout(function () { submit.disabled = true; submit.textContent = 'Sending…'; }, 0);
    }
  }, true);

  // Coming back to this page (browser Back) shows the form ready again
  window.addEventListener('pageshow', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fh-contact-form] .fh-cf-submit'), function (b) {
      b.disabled = false;
      if (b.getAttribute('data-label')) b.textContent = b.getAttribute('data-label');
    });
  });

  function boot() { initRolls(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initRolls(e.target); });
})();
